"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScrollAlphaTestnet = void 0;
const chainExplorerLink_1 = require("../../helpers/chainExplorerLink");
const scrollAlphaExplorerUrl = 'https://blockscout.scroll.io/';
exports.ScrollAlphaTestnet = {
    chainId: 534353,
    chainName: 'Scroll Alpha Testnet',
    isTestChain: true,
    isLocalChain: false,
    multicallAddress: '0xA940214bd0387862617E9E6EA3E801DF158692a6',
    multicall2Address: '0xD5A9877C39838676955F487faC80dc9551E4921C',
    rpcUrl: 'https://alpha-rpc.scroll.io/l2',
    nativeCurrency: {
        name: 'ETH',
        symbol: 'ETH',
        decimals: 18,
    },
    blockExplorerUrl: scrollAlphaExplorerUrl,
    getExplorerAddressLink: (0, chainExplorerLink_1.getAddressLink)(scrollAlphaExplorerUrl),
    getExplorerTransactionLink: (0, chainExplorerLink_1.getTransactionLink)(scrollAlphaExplorerUrl),
};
//# sourceMappingURL=scroll.js.map